export default function FullPageLoader() {
  return (
    <div className="flex min-h-dvh items-center justify-center bg-background" role="status">
      <div className="text-center">
        <div className="mx-auto h-10 w-10 animate-spin rounded-full border-4 border-secondary/20 border-t-primary" />
        <p className="mt-4 text-sm font-medium text-text-secondary">Cargando tu espacio…</p>
      </div>
    </div>
  )
}
